import {
  DATA_METRICS,
  REP_STACK_METRICS,
  REP_TREND_METRICS,
  GATEWAY_METRICS,
  LIST_METRICS,
} from '../componentKeys.js'

const identifiers = {
  key: 'conversionRate',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Conversion Rate',
  },
}

const keys = {
  componentKeys: [
    DATA_METRICS,
    REP_STACK_METRICS,
    REP_TREND_METRICS,
    GATEWAY_METRICS,
    LIST_METRICS,
  ],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'divide',
  dividend: { stat: 'qualified' },
  divisor: { stat: 'calls' },
  isRate: true,
}

const conversionRate = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { conversionRate }
